// @ts-nocheck
import React from 'react';
import dynamic from 'next/dynamic';
import HeadNext from 'next/head';
import NextDefaultError from 'next/error';
import useServerEnv from '@magalu/rave/config/useServerEnv';
import useClientEnv from '@magalu/rave/config/useClientEnv';

import { client  } from '@magalu/rave/graphql';
import { parseHeaders, shouldRender, middlewareClientExecutor, middlewareServerExecutor } from '@magalu/rave/utils';
import { withEventsLayer } from '@magalu/rave/hocs';

import { ErrorBoundary } from '@magalu/rave/errorBoundary';

import events , { config as eventsConfig }   from '../../events';

import { Head } from '@magalu/rave/components';
import { LazyLoading } from '@magalu/rave/components';
import { ActivityDetection } from '@magalu/rave/components';

// Modules
import { Preconnect } from '@magalu/rave/components';
import GoogleTagManager from '@magalu/ecomm-components/rave/scripts/GoogleTagManager';
import { Script } from '@magalu/rave/components';
import AllIn from '@magalu/ecomm-components/rave/scripts/AllIn';
import Criteo from '@magalu/ecomm-components/rave/scripts/Criteo';
import Bing from '@magalu/ecomm-components/rave/scripts/Bing';
import TikTok from '@magalu/ecomm-components/rave/scripts/TikTok';
import RTBHouse from '@magalu/ecomm-components/rave/scripts/RTBHouse';
import Stewie from '@magalu/ecomm-components/rave/scripts/Stewie';
import SpotifyAdAnalytics from '@magalu/ecomm-components/rave/scripts/SpotifyAdAnalytics';
  /**
  * for client modules in typescript, need to use dynamic<T> as any
  * read: https://github.com/vercel/next.js/issues/4515
  */
const Hotjar = dynamic<any>(() =>
  import('@magalu/ecomm-components/rave/scripts/Hotjar'), {
  ssr: false
});
import Vwo from '@magalu/ecomm-components/rave/scripts/Vwo';
  /**
  * for client modules in typescript, need to use dynamic<T> as any
  * read: https://github.com/vercel/next.js/issues/4515
  */
const Loader = dynamic<any>(() =>
  import('@magalu/ecomm-components/rave/Loader'), {
  ssr: false
});
  /**
  * for client modules in typescript, need to use dynamic<T> as any
  * read: https://github.com/vercel/next.js/issues/4515
  */
const StateLoader = dynamic<any>(() =>
  import('@magalu/ecomm-components/rave/StateLoader'), {
  ssr: false
});
  /**
  * for client modules in typescript, need to use dynamic<T> as any
  * read: https://github.com/vercel/next.js/issues/4515
  */
const AdsBanner = dynamic<any>(() =>
  import('@magalu/ecomm-components/rave/AdsBanner'), {
  ssr: false
});
import Header from '@magalu/ecomm-components/rave/Header';
import EventPageViewDispatcher from '@magalu/ecomm-components/rave/EventPageViewDispatcher';
import PageLoading from '@magalu/ecomm-components/components/PageLoading';
import Row from '@magalu/ecomm-components/components/Row';
import Heading from '@magalu/ecomm-components/rave/Heading';
import Image from '@magalu/ecomm-components/components/Image';
import Button from '@magalu/ecomm-components/rave/Button';
  /**
  * for client modules in typescript, need to use dynamic<T> as any
  * read: https://github.com/vercel/next.js/issues/4515
  */
const BackToTop = dynamic<any>(() =>
  import('@magalu/ecomm-components/components/BackToTop'), {
  ssr: false
});
import Footer from '@magalu/ecomm-components/rave/Footer';


// Data Source
import PageQuery from './query.json';

// Data Source Configs
import { configs as dataSourceConfigs } from '../../datasource/config';
const { cachePolicies = {}, localTypeDefs,  linkMiddlewares = [] } = dataSourceConfigs  as any ;
import { getParsedQuery, useRouter, useCookies, withRouter, getDeviceInfo } from '@magalu/rave/router';


import {
    getGlobalClassName, routeInfo, getComponents, getHeadProps,
    dataSource, getPageVariables, middlewaresArgs,
    manifest, config as raveConfig, componentsList
  } from './settings';

import routes from '../../rave-routes';


const Container = (props : Record<string, any>  = {}) => {

  const { client: clientConfig } = useClientEnv();
  const route = useRouter();

  const pageProps = { ...props, route, manifest, appConfig: raveConfig, clientConfig };

  const headProps = getHeadProps(pageProps);

  const componentProps = getComponents(pageProps);
  const className = getGlobalClassName(pageProps);
  const gridStyleHtml = {__html: `#500{display: grid;grid-template-areas: 'header header header' '. content .' 'footer footer footer';grid-template-columns: 1fr 100% 1fr;grid-template-rows: auto minmax(100vh, max-content) auto;}`}


  return (
    <>
      <HeadNext><style dangerouslySetInnerHTML={gridStyleHtml}/></HeadNext>
      <div id="500" className={className}>
        <Head {...props} {...headProps} />
          <header { ...{"style":{"gridArea":"header"}} }>
            
            
            
            
            <Preconnect { ...props} {...(componentProps['header-preconnect-0']?.props || {})}/>
            
            
            
            
            
            
            
            <GoogleTagManager { ...props} {...(componentProps['header-google-tag-manager-1']?.props || {})}/>
            
            
            
            
            
            
            
            <Script { ...props} {...(componentProps['header-script-2']?.props || {})}/>
            
            
            
            
            
            
            
            <AllIn { ...props} {...(componentProps['header-all-in-3']?.props || {})}/>
            
            
            
            
            
            
            
            <Criteo { ...props} {...(componentProps['header-criteo-4']?.props || {})}/>
            
            
            
            
            
            
            
            <Bing { ...props} {...(componentProps['header-bing-5']?.props || {})}/>
            
            
            
            
            
            
            
            <TikTok { ...props} {...(componentProps['header-tik-tok-6']?.props || {})}/>
            
            
            
            
            
            
            
            <RTBHouse { ...props} {...(componentProps['header-rtbhouse-7']?.props || {})}/>
            
            
            
            
            
            
            
            <Stewie { ...props} {...(componentProps['header-stewie-8']?.props || {})}/>
            
            
            
            
            
            
            
            <SpotifyAdAnalytics { ...props} {...(componentProps['header-spotify-ad-analytics-9']?.props || {})}/>
            
            
            
            
            <ActivityDetection {...componentProps['header-hotjar-10'].csr.props}>
            
            
            <Hotjar { ...props} {...(componentProps['header-hotjar-10']?.props || {})}/>
            
            </ActivityDetection>
            
            
            
            
            
            <Vwo { ...props} {...(componentProps['header-vwo-11']?.props || {})}/>
            
            
            
            
            <ActivityDetection {...componentProps['header-loader-12'].csr.props}>
            
            
             
            <Loader { ...props} {...(componentProps['header-loader-12']?.props || {})}>
            
            
            
            
            <PageLoading { ...props} {...(componentProps['header-loader-12-children-page-loading-0']?.props || {})}/>
            
            
            
             
            </Loader>
            
            </ActivityDetection>
            
            
            <ActivityDetection {...componentProps['header-state-loader-13'].csr.props}>
            
            
             
            <StateLoader { ...props} {...(componentProps['header-state-loader-13']?.props || {})}>
            
            <ActivityDetection {...componentProps['header-state-loader-13-children-page-loading-0'].csr.props}>
            
            
            <PageLoading { ...props} {...(componentProps['header-state-loader-13-children-page-loading-0']?.props || {})}/>
            
            </ActivityDetection>
            
             
            </StateLoader>
            
            </ActivityDetection>
            
            <LazyLoading {...componentProps['header-ads-banner-14'].csr.props}>
            
            
            
            <AdsBanner { ...props} {...(componentProps['header-ads-banner-14']?.props || {})}/>
            
            
            </LazyLoading>
            
            
            
            
            <Header { ...props} {...(componentProps['header-header-15']?.props || {})}/>
            
            
            
            
            
            
            
            <EventPageViewDispatcher { ...props} {...(componentProps['header-event-page-view-dispatcher-16']?.props || {})}/>
            
            
            
          </header>
          <section { ...{"style":{"gridArea":"content"}} }>
            
            
            
            
             
            <Row { ...props} {...(componentProps['content-row-0']?.props || {})}>
            
            
            
            
            <Heading { ...props} {...(componentProps['content-row-0-children-heading-0']?.props || {})}/>
            
            
            
             
            
            
            
            
            <Heading { ...props} {...(componentProps['content-row-0-children-heading-1']?.props || {})}/>
            
            
            
             
            
            
            
            
            <Heading { ...props} {...(componentProps['content-row-0-children-heading-2']?.props || {})}/>
            
            
            
             
            
            
            
            
            <Image { ...props} {...(componentProps['content-row-0-children-image-3']?.props || {})}/>
            
            
            
             
            
            
            
            
            <Button { ...props} {...(componentProps['content-row-0-children-button-4']?.props || {})}/>
            
            
            
             
            </Row>
            
            
            
          </section>
          <footer { ...{"style":{"gridArea":"footer"}} }>
            
            <ActivityDetection {...componentProps['footer-back-to-top-0'].csr.props}>
            
            
            <BackToTop { ...props} {...(componentProps['footer-back-to-top-0']?.props || {})}/>
            
            </ActivityDetection>
            
            
            
            
            
            <Footer { ...props} {...(componentProps['footer-footer-1']?.props || {})}/>
            
            
            
          </footer>
      </div>
    </>
  )
};

export default withRouter(
  withEventsLayer(
  Container,
    {
      routeInfo,
      events: events(),
      eventsCustomConfig: eventsConfig,
      dataStoreSetupKey: "userInfo",
    }
  ),
  {...routeInfo, manifest },
  false,
  routes
);
